const state = {
  productInformations: {
    images: []
  },
  currentProduct: {
    currency: '',
    colorCapacityMapping: [],
    currentPlanIndex: 0,
    sku: '',
    device_plan_sku: '',
    phone: '',
    color: {},
    capacity: {
      index: 0
    },
    plan: {},
    instalment: {},
    formReady: false
  },
  openProduct: {
    currency: '',
    colorCapacityMapping: [],
    currentPlanIndex: 0,
    sku: '',
    device_plan_sku: '',
    phone: '',
    color: {},
    capacity: {
      index: 0
    },
    plan: {},
    instalment: {},
    formReady: false
  },
  addToCartButtonState: {
    disabled: true,
    tabindex: -1,
    loading: false,
    discret: true
  },
  $t: null
}

export default state